import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ListingInterface,
  ListingsInterface,
  PaginationInfo,
  ListingsResponse,
} from "../../../types";
import { IListing } from "../../../views/common/utils/interfaces";

interface ListingsState {
  loading: boolean;
  listing: IListing | null;
  listings: ListingsInterface[] | ListingInterface[];
  filteredListings: (ListingsInterface | ListingInterface)[];
  error: string | null;
  pagination: PaginationInfo;
  isLoadingMore: boolean;
}

const initialState: ListingsState = {
  loading: false,
  listings: [],
  listing: null,
  filteredListings: [],
  error: null,
  pagination: {
    next: null,
    previous: null,
    count: 0,
  },
  isLoadingMore: false,
};

const listingsSlice = createSlice({
  name: "listings",
  initialState,
  reducers: {
    // Initial fetch
    fetchListings(state) {
      state.loading = true;
      state.error = null;
      state.isLoadingMore = false;
    },

    // Success for initial fetch
    fetchListingsSuccess(state, action: PayloadAction<ListingsResponse>) {
      state.loading = false;
      state.error = null;
      state.listings = action.payload.data;
      state.filteredListings = action.payload.data;
      state.pagination = {
        next: action.payload.next,
        previous: action.payload.previous,
        count: action.payload.count,
      };
      state.isLoadingMore = false;
    },

    // Success for loading more (append)
    fetchListingsMoreSuccess(state, action: PayloadAction<ListingsResponse>) {
      state.loading = false;
      state.error = null;
      state.listings = [...state.listings, ...action.payload.data];
      state.filteredListings = [
        ...state.filteredListings,
        ...action.payload.data,
      ];
      state.pagination = {
        next: action.payload.next,
        previous: action.payload.previous,
        count: action.payload.count,
      };
      state.isLoadingMore = false;
    },

    // Set loading more state
    fetchListingsMore(state) {
      state.isLoadingMore = true;
      state.error = null;
    },

    fetchAuthListingSuccess(state, action: PayloadAction<IListing>) {
      state.loading = false;
      state.error = null;
      state.listing = action.payload;
      state.isLoadingMore = false;
    },

    setFilteredListings(
      state,
      action: PayloadAction<(ListingsInterface | ListingInterface)[]>
    ) {
      state.filteredListings = action.payload;
    },

    clearFilteredListings(state) {
      state.filteredListings = state.listings;
    },

    fetchListingsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.isLoadingMore = false;
    },

    toggleFavoriteListing(state, action: PayloadAction<string>) {
      state.listings = state.listings.map((listing) => {
        if (listing.lid !== action.payload) return listing;
        return {
          ...listing,
          saved_by_user: !listing.saved_by_user,
        };
      });

      state.filteredListings = state.filteredListings.map((listing) => {
        if (listing.lid !== action.payload) return listing;
        return {
          ...listing,
          saved_by_user: !listing.saved_by_user,
        };
      });
    },

    // Clear all listings (useful for resetting state)
    clearListings(state) {
      state.listings = [];
      state.filteredListings = [];
      state.pagination = {
        next: null,
        previous: null,
        count: 0,
      };
      state.loading = false;
      state.isLoadingMore = false;
      state.error = null;
    },
  },
});

export const {
  fetchListings,
  fetchListingsFailure,
  fetchListingsSuccess,
  fetchListingsMoreSuccess,
  fetchListingsMore,
  fetchAuthListingSuccess,
  setFilteredListings,
  clearFilteredListings,
  toggleFavoriteListing,
  clearListings,
} = listingsSlice.actions;

export default listingsSlice.reducer;
// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { ListingInterface, ListingsInterface } from "../../../types";
// import { IListing } from "../../../views/common/utils/interfaces";

// interface ListingsState {
//   loading: boolean;
//   listing: IListing | null;
//   listings: ListingsInterface[] | ListingInterface[];
//   filteredListings: (ListingsInterface | ListingInterface)[];
//   error: string | null;
// }

// const initialState: ListingsState = {
//   loading: false,
//   listings: [],
//   listing: null,
//   filteredListings: [],
//   error: null,
// };

// const listingsSlice = createSlice({
//   name: "listings",
//   initialState,
//   reducers: {
//     fetchListings(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     fetchListingsSuccess(state, action: PayloadAction<ListingsInterface[]>) {
//       state.loading = false;
//       state.error = null;
//       state.listings = action.payload;
//       state.filteredListings = action.payload;
//     },
//     fetchAuthListingSuccess(state, action: PayloadAction<IListing>) {
//       state.loading = false;
//       state.error = null;
//       state.listing = action.payload;
//     },
//     setFilteredListings(
//       state,
//       action: PayloadAction<(ListingsInterface | ListingInterface)[]>
//     ) {
//       state.filteredListings = action.payload;
//     },
//     clearFilteredListings(state) {
//       state.filteredListings = state.listings;
//     },
//     fetchListingsFailure(state, action: PayloadAction<string>) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     toggleFavoriteListing(state, action: PayloadAction<string>) {
//       state.listings.map((listing) => {
//         if (listing.lid !== action.payload) return listing;
//         else {
//           listing.saved_by_user = !listing.saved_by_user;
//           return listing;
//         }
//       });
//     },
//   },
// });

// export const {
//   fetchListings,
//   fetchListingsFailure,
//   fetchListingsSuccess,
//   fetchAuthListingSuccess,
//   setFilteredListings,
//   clearFilteredListings,
// } = listingsSlice.actions;

// export default listingsSlice.reducer;
